import { FaChevronRight } from "react-icons/fa";
import styled, { css } from "styled-components";
import theme from "../../UI/theme";
import Button from "../UiComponents/Button";
import { getItemIcon } from "./styling/Icons";

const BreadcrumbsContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
    width: fill-available;
    overflow-x: auto;
    line-height: 1.1rem;
    box-sizing: border-box;
`

const CrumbContainer = styled.div`
    display: flex;
    gap: 10px;
    justify-content: center;
    align-items: center;

    > svg {
        font-size: 1.1rem;
        max-width: 1.1rem;
        max-height: 1.1rem;
    }
`

const CrumbLabel = styled.label`
    display: flex;
    align-items: center;
    gap: 5px;
    border-radius: 5px;
    color: ${theme.colors.textGray};
    stroke: ${theme.colors.textGray};
    white-space: nowrap;
    height: 100%;

    &:hover {
        text-decoration: underline;
        cursor: pointer;
    }

    > svg {
        font-size: 1.1rem;
        max-width: 1.1rem;
        max-height: 1.1rem;
    }

    ${props => props.selected && css`
        color: ${theme.colors.greenReadable};
        stroke: ${theme.colors.greenReadable};
    `}
`

const ClearFilterButton = styled(Button)`
    white-space: nowrap;
    line-height: 1.1rem;
    padding: 5px;
    visibility: ${props => props.visibility ? props.visibility : ''};
`

const Breadcrumbs = props => {
    return <BreadcrumbsContainer>
        <ClearFilterButton
            small
            tertiary
            visibility={props.selectedItemHierarchy ? 'visible' : 'hidden'}
            onClick={() => props.setSelectedItemHierarchy(null)}>Clear</ClearFilterButton>

        {props.selectedItemHierarchy?.map((item, index) => {
            const ItemIcon = getItemIcon(item.type);
            const isSelectedElement = index === props.selectedItemHierarchy?.length - 1;

            return <CrumbContainer key={index}>
                <CrumbLabel
                    selected={isSelectedElement}
                    onClick={() => props.setSelectedItemHierarchy(prev => {
                        return prev?.slice(0, index + 1);
                    })}
                >
                    <ItemIcon /> {item.name}
                </CrumbLabel>
                {!isSelectedElement ? <FaChevronRight /> : <></>}
            </CrumbContainer>
        })}
    </BreadcrumbsContainer>
}

export default Breadcrumbs;